import axios from 'axios';
import { API_HOST } from 'configs/api';
import { PAGE_NAV } from 'configs/page';
import auth from 'utils/auth';
import { getOrStartRefresh } from 'services/refreshManager';

const apiClient = axios.create({
    baseURL: API_HOST,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(
    config => {
        config.headers.Authorization = `Bearer ${auth.getAccessToken()}`;
        return config;
    },
    error => Promise.reject(error)
);

apiClient.interceptors.response.use(
    response => response,
    async error => {
        if (error.response) {
            if (error.response.status === 403) return Promise.reject(error);

            const config = error.config;
            if (config.maxRetries === undefined) config.maxRetries = 3;
            config.__retryCount = config.__retryCount || 0;

            if (config.__retryCount < config.maxRetries) {
                config.__retryCount += 1;

                if (error.response.status === 401 && !config._retry) {
                    config._retry = true;

                    return getOrStartRefresh().then(
                        (accessToken) => {
                            config.headers = {
                                ...config.headers,
                                Authorization: `Bearer ${accessToken}`,
                            };
                            return new Promise(resolve => setTimeout(resolve, 300))
                                .then(() => apiClient(config));
                        },
                        () => {
                            auth.clearTokens();
                            window.location.href = PAGE_NAV.LOGIN;
                            return Promise.reject(error);
                        }
                    );
                }

                await new Promise(resolve => setTimeout(resolve, 300));
                return apiClient(config);
            }

            return Promise.reject(error);
        }

        // Network error or no response — do not clear the session;
        // a transient outage should not log the user out.
        return Promise.reject(error);
    }
);

export default apiClient;
